import React from "react";
import { Global } from "@emotion/react";

export const Fonts = (): React.ReactElement => (
	<Global
		styles={`
      @font-face {
          font-family: 'SF Pro';
          font-display: swap;
          src: url('./fonts/SFPro.ttf');
        }
      @font-face {
        font-family: 'VivoType';
        font-display: swap;
        src: url('./fonts/VivoType.ttf');
      }
    `}
	/>
);

export const fonts = {
	heading: "SF pro",
};
